import { FeatureFlagStore } from "@frontend-shared/utils";

import { localStorageAdapter } from "./storage-adapter";

// NOTE: NSAI-1249 — the per-browser opt-ins behind the registry in
// @frontend-shared/constants/feature-flags. On web these are still set by hand
// from DevTools (`localStorage.enabled_anonymization_lab = "true"`), which is
// exactly the affordance mobile lacks and why mobile grew a dev-settings
// screen over the same store.
export const featureFlagStore = new FeatureFlagStore(localStorageAdapter);
